module.exports = __webpack_public_path__ + "static/img/why-micro-3.0c8b8041.svg";